<table *ngIf="carDetails" class="table table-hover">
  <tbody>
    <tr>
      <td>Body Type</td>
      <td><b>{{carDetails.variant.specifications?.bodyType}}</b></td>
    </tr>
    <tr>
      <td>Brake Type Front</td>
      <td><b>{{carDetails.variant.specifications?.brakeTypeFront}}</b></td>
    </tr>
    <tr>
      <td>Brake Type Rear</td>
      <td><b>{{carDetails.variant.specifications?.brakeTypeRear}}</b></td>
    </tr>
    <tr>
      <td>Displacement</td>
      <td><b>{{carDetails.variant.specifications?.displacement}}</b></td>
    </tr>
    <tr>
      <td>Drive Train</td>
      <td><b>{{carDetails.variant.specifications?.driveTrain}}</b></td>
    </tr>
    <tr>
      <td>Fuel Type</td>
      <td><b>{{carDetails.variant.specifications?.fuelType}}</b></td>
    </tr>
    <tr>
      <td>Height</td>
      <td><b>{{carDetails.variant.specifications?.height}}</b> mm</td>
    </tr>
    <tr>
      <td>Length</td>
      <td><b>{{carDetails.variant.specifications?.length}}</b> mm</td>
    </tr>
    <tr>
      <td>Width</td>
      <td><b>{{carDetails.variant.specifications?.width}}</b> mm</td>
    </tr>
    <tr>
      <td>Max Power Bph</td>
      <td><b>{{carDetails.variant.specifications?.maxPowerBph}}</b> bph</td>
    </tr>
    <tr>
      <td>Max Power Rpm</td>
      <td><b>{{carDetails.variant.specifications?.maxPowerRpm}}</b> rpm</td>
    </tr>
    <tr>
      <td>Max Torque Nm</td>
      <td><b>{{carDetails.variant.specifications?.maxTorqueNm}}</b> Nm</td>
    </tr>
    <tr>
      <td>Max Torque Rpm</td>
      <td><b>{{carDetails.variant.specifications?.maxTorqueRpm}}</b> rpm</td>
    </tr>
    <tr>
      <td>Number Of Doors</td>
      <td><b>{{carDetails.variant.specifications?.numberOfDoors}}</b></td>
    </tr>
    <tr>
      <td>Number Of Gears</td>
      <td><b>{{carDetails.variant.specifications?.numberOfGears}}</b></td>
    </tr>
    <tr>
      <td>Rim Size Front</td>
      <td><b>{{carDetails.variant.specifications?.rimSizeFront}}</b></td>
    </tr>
    <tr>
      <td>Rim Size Rear</td>
      <td><b>{{carDetails.variant.specifications?.rimSizeRear}}</b></td>
    </tr>
    <tr>
      <td>Seating Capacity</td>
      <td><b>{{carDetails.variant.specifications?.seatingCapacity}}</b></td>
    </tr>
    <tr>
      <td>Spare Wheel Type</td>
      <td><b>{{carDetails.variant.specifications?.spareWheelType}}</b></td>
    </tr>
    <tr>
      <td>steeringType</td>
      <td><b>{{carDetails.variant.specifications?.steeringType}}</b></td>
    </tr>
    <tr>
      <td>Tank Capacity</td>
      <td><b>{{carDetails.variant.specifications?.tankCapacityL}}</b>L</td>
    </tr>
    <tr>
      <td>Transmission Type</td>
      <td><b>{{carDetails.variant.specifications?.transmissionType}}</b></td>
    </tr>
    <tr>
      <td>Wheel Type</td>
      <td><b>{{carDetails.variant.specifications?.wheelType}}</b></td>
    </tr>
    <tr>
      <td>Wheelbase</td>
      <td><b>{{carDetails.variant.specifications?.wheelbase}}</b></td>
    </tr>
  </tbody>
</table>